import T from '@wojtekmaj/react-t';

import { Text } from './loading_text.styles';

type LoadingTextProps = {
  withMargin?: boolean;
};

export default function LoadingText({ withMargin = true }: LoadingTextProps) {
  return (
    <Text withMargin={withMargin}>
      <T>Loading…</T>
    </Text>
  );
}
